import React from 'react'
import { Box, Typography } from '@mui/material'
import { grey } from '../../colors'
import { useTheme } from '@mui/material/styles'
import { buildMetaInfo } from '../../helpers/buildMetaInfo'

export interface ChangeMetaInfoProps {
  lastEditedBy?: string
  lastEditedAt?: string
}

export const LastUpdateMeta: React.FC<ChangeMetaInfoProps> = ({ lastEditedBy, lastEditedAt }) => {
  if (!lastEditedBy && !lastEditedAt) return null

  const lastUpdateInformation = buildMetaInfo(lastEditedBy, lastEditedAt)
  const theme = useTheme()

  return (
        <Box
            sx={{
              color: grey[850],
              marginRight: theme.spacing(7.5),
              marginLeft: theme.spacing(3),
              pt: theme.spacing(1)
            }}
        >
            <Box display="flex" flexDirection="column" >
                <Typography variant="caption" color="text.secondary">
                    Last Updated: {lastUpdateInformation?.lastEditedAt}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    By: {lastUpdateInformation?.lastEditedBy}
                </Typography>
            </Box>
        </Box>
  )
}
